import { Address } from "@msuite/ui/address";
import { Email, Link, Phone } from "@msuite/ui/link";
import { localized } from "@msuite/ui/localization";
import { StatusIndicator } from "@msuite/ui/status-indicator";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { getAddressString, guardString } from "@msuite/utils/strings";
import type { ServiceFulfillmentPartner } from "@msuite/utils/types";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<ServiceFulfillmentPartner>();

export const columns = [
	columnHelper.accessor("_contact._type.name", {
		id: "type",
		header: localized("general.type"),
		cell: (cell) =>
			cell.row.original._contact._type ? (
				<div className="h-stack">
					<StatusIndicator color={cell.row.original._contact._type.color} />
					<p>{cell.getValue()}</p>
				</div>
			) : (
				guardString(null)
			),
	}),
	columnHelper.accessor("_contact.name", {
		id: "name",
		header: localized("contacts.fields.name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor((row) => getAddressString(row._contact), {
		id: "address",
		header: localized("address.address"),
		cell: (cell) => <Address item={cell.row.original._contact} />,
	}),
	columnHelper.accessor("_contact.email", {
		header: localized("personnel.fields.email"),
		id: "email",
		cell: (cell) => <Email>{guardString(cell.getValue())}</Email>,
	}),
	columnHelper.accessor("_contact.phone", {
		header: localized("personnel.fields.phone"),
		id: "phone",
		cell: (cell) => <Phone>{guardString(cell.getValue())}</Phone>,
	}),
	columnHelper.accessor((row) => row._contact._relatedContact?.name, {
		id: "relatedContact",
		header: localized("contacts.superior_contact"),
		cell: (cell) =>
			cell.row.original._contact._relatedContact?.id ? (
				<Link href={`/contacts/${cell.row.original._contact._relatedContact?.id}`}>
					{guardString(cell.getValue())}
				</Link>
			) : (
				guardString(null)
			),
	}),
	createRowActions(RowActions),
];
